import React from 'react';

import { 
    makeStyles,
    Box
} from '@material-ui/core';

const useStyles = makeStyles({
    titulo: {
        color: '#dc0028',
        fontSize: 24
    },
    container: {
        backgroundColor: '#FFFFFF',
        flexGrow: 8
    },
    divider: {
        height: 3,
        backgroundColor: '#f4f4f4',
        marginTop: 10
    }
});

interface TabPanelProps {
    value: number;
    index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ value, index, children }) => {

    const clases = useStyles();
    
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        className={clases.container}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }

export default TabPanel;